import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Alumno Francisco',
  initials: 'AF',
  avatarColor: '#6B7280',
  studentMsg: 'Empecé la mentoría sin creer que algo iba a cambiar. Llevo 3 semanas sin fallar ni un solo hábito. Nunca pensé que la disciplina se podía entrenar así de directo.',
  studentTime: '9:32 a. m.',
  mentorMsg: 'Nos alegra mucho que la mentoría te esté dando los resultados que tanto querías',
  mentorTime: '9:33 a. m.'
}, {
  name: 'Alumno Martín',
  initials: 'AM',
  avatarColor: '#4B5563',
  studentMsg: 'Bro gracias en serio. Llevaba 2 años diciéndome que iba a cambiar y nunca pasaba nada. En 4 semanas hice más que en todo ese tiempo. Los en vivos son una locura graciass',
  studentTime: '11:07 a. m.',
  mentorMsg: 'Gracias a vos por unirte a la mentoría',
  mentorTime: '11:08 a. m.'
}, {
  name: 'Alumna Valentina',
  initials: 'AV',
  avatarColor: '#374151',
  studentMsg: 'Una locura esta mentoría. Hace 3 días tuve mis primeros resultados reales. Apliqué todo lo que trabajamos y por fin siento que tengo el control de mi vida',
  studentTime: '10:38 a. m.',
  mentorMsg: 'Nos alegra mucho que te sirvió para generar tus primeros resultados',
  mentorTime: '10:38 a. m.'
}];
// WhatsApp wallpaper pattern (the classic WA background)
const WA_BG = '#0b141a';
const WA_HEADER = '#1f2c33';
const WA_BUBBLE_IN = '#1f2c33';
const WA_BUBBLE_OUT = '#005c4b';
const WA_TICK = '#53bdeb';
function WaChat({
  t,
  index
}: {
  t: (typeof testimonials)[0];
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.55,
    delay: index * 0.15
  }} className="rounded-xl overflow-hidden shadow-2xl" style={{
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }} data-id="element-381">
      {/* ── Header ── */}
      <div className="flex items-center gap-3 px-3 py-2" style={{
      background: WA_HEADER
    }} data-id="element-382">
        {/* Back arrow + badge */}
        <div className="flex items-center gap-1" data-id="element-383">
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white" data-id="element-384">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" data-id="element-385" />
          </svg>
        </div>

        {/* Avatar */}
        <div className="w-9 h-9 rounded-full flex items-center justify-center shrink-0 text-white text-sm font-semibold" style={{
        background: t.avatarColor
      }} data-id="element-386">
          {t.initials}
        </div>

        {/* Name + status */}
        <div className="flex-1 min-w-0" data-id="element-387">
          <p className="text-white text-[14px] font-semibold leading-tight truncate" data-id="element-388">
            {t.name}
          </p>
          <p className="text-[#8696a0] text-[12px]" data-id="element-389">en línea</p>
        </div>

        {/* Icons */}
        <div className="flex items-center gap-4" data-id="element-390">
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#aebac1" data-id="element-391">
            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" data-id="element-392" />
          </svg>
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#aebac1" data-id="element-393">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" data-id="element-394" />
          </svg>
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#aebac1" data-id="element-395">
            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" data-id="element-396" />
          </svg>
        </div>
      </div>

      {/* ── Chat body ── */}
      <div className="px-3 py-3 flex flex-col gap-2" style={{
      background: WA_BG,
      // Classic WA wallpaper subtle pattern
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Cpath d='M0 0h80v80H0z' fill='%230b141a'/%3E%3Cpath d='M20 10c0 5.52-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0s10 4.48 10 10zm40 0c0 5.52-4.48 10-10 10S40 15.52 40 10 44.48 0 50 0s10 4.48 10 10zM20 50c0 5.52-4.48 10-10 10S0 55.52 0 50s4.48-10 10-10 10 4.48 10 10zm40 0c0 5.52-4.48 10-10 10S40 55.52 40 50s4.48-10 10-10 10 4.48 10 10z' fill='%23ffffff' fill-opacity='0.015'/%3E%3C/svg%3E")`
    }} data-id="element-397">
        {/* Date pill */}
        <div className="flex justify-center my-1" data-id="element-398">
          <span className="text-[#e9edef] text-[11px] px-3 py-[3px] rounded-lg" style={{
          background: 'rgba(17,27,33,0.9)'
        }} data-id="element-399">
            Hoy
          </span>
        </div>

        {/* Encryption notice */}
        <div className="mx-auto max-w-[90%] rounded-lg px-3 py-2 text-center mb-1" style={{
        background: 'rgba(255,217,102,0.1)',
        border: '1px solid rgba(255,217,102,0.15)'
      }} data-id="element-400">
          <p className="text-[11px] leading-relaxed" style={{
          color: '#ffd966'
        }} data-id="element-401">
            🔒 Los mensajes y las llamadas están cifrados de extremo a extremo.
          </p>
        </div>

        {/* Incoming bubble (alumno) */}
        <div className="flex justify-start" data-id="element-402">
          <div className="relative max-w-[85%] rounded-tr-2xl rounded-br-2xl rounded-bl-2xl px-3 pt-2 pb-1" style={{
          background: WA_BUBBLE_IN
        }} data-id="element-403">
            {/* Tail */}
            <svg className="absolute -left-[8px] top-0" width="8" height="13" viewBox="0 0 8 13" data-id="element-404">
              <path d="M8 0 Q0 0 0 13 L8 0Z" fill={WA_BUBBLE_IN} data-id="element-405" />
            </svg>
            <p className="text-[#e9edef] text-[14px] leading-[1.45]" data-id="element-406">
              {t.studentMsg}
            </p>
            <p className="text-[#8696a0] text-[11px] text-right mt-[2px]" data-id="element-407">
              {t.studentTime}
            </p>
          </div>
        </div>

        {/* Outgoing bubble (mentor) */}
        <div className="flex justify-end" data-id="element-408">
          <div className="relative max-w-[85%] rounded-tl-2xl rounded-bl-2xl rounded-br-2xl px-3 pt-2 pb-1" style={{
          background: WA_BUBBLE_OUT
        }} data-id="element-409">
            {/* Tail */}
            <svg className="absolute -right-[8px] top-0" width="8" height="13" viewBox="0 0 8 13" data-id="element-410">
              <path d="M0 0 Q8 0 8 13 L0 0Z" fill={WA_BUBBLE_OUT} data-id="element-411" />
            </svg>
            <p className="text-[#e9edef] text-[14px] leading-[1.45]" data-id="element-412">
              {t.mentorMsg}
            </p>
            <div className="flex items-center justify-end gap-1 mt-[2px]" data-id="element-413">
              <p className="text-[#8696a0] text-[11px]" data-id="element-414">{t.mentorTime}</p>
              {/* Double blue tick */}
              <svg viewBox="0 0 16 11" width="16" height="11" fill="none" data-id="element-415">
                <path d="M1 5.5L5 9.5L11 2" stroke={WA_TICK} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" data-id="element-416" />
                <path d="M6 9.5L12 2" stroke={WA_TICK} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" data-id="element-417" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* ── Input bar ── */}
      <div className="flex items-center gap-2 px-2 py-2" style={{
      background: WA_HEADER
    }} data-id="element-418">
        {/* Emoji */}
        <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" fill="#8696a0" data-id="element-419">
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" data-id="element-420" />
        </svg>

        {/* Text input */}
        <div className="flex-1 rounded-full px-4 py-2" style={{
        background: '#2a3942'
      }} data-id="element-421">
          <p className="text-[#8696a0] text-[14px]" data-id="element-422">Mensaje</p>
        </div>

        {/* Mic */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0" style={{
        background: '#00a884'
      }} data-id="element-423">
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white" data-id="element-424">
            <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V6z" data-id="element-425" />
            <path d="M17 12c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-426" />
          </svg>
        </div>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  return <section className="py-24 bg-[#080808] relative overflow-hidden" data-id="element-427">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#C9A84C]/5 rounded-full blur-[120px]" data-id="element-428" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-429">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-430">
          <span className="text-[#C9A84C] tracking-[0.2em] text-xs font-bold uppercase mb-3 block" data-id="element-431">
            Lo que dicen los que ya dieron el paso
          </span>
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white" data-id="element-432">
            RESULTADOS REALES
          </h2>
          <div className="w-12 h-[1px] bg-[#C9A84C] mx-auto mt-4" data-id="element-433" />
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-434">
          {testimonials.map((t, i) => <WaChat key={i} t={t} index={i} data-id="element-435" />)}
        </div>
      </div>
    </section>;
}